import { render, staticRenderFns } from "./WidgetMetaForm.vue?vue&type=template&id=9705ed2e&scoped=true"
import script from "./WidgetMetaForm.vue?vue&type=script&lang=js"
export * from "./WidgetMetaForm.vue?vue&type=script&lang=js"
import style0 from "./WidgetMetaForm.vue?vue&type=style&index=0&id=9705ed2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9705ed2e",
  null
  
)

export default component.exports